import styled, { css } from 'styled-components';

import Tooltip from '../../../Tooltip';

interface ContainerProps {
  isFocused: boolean;
  isField: boolean;
  isErrored: boolean;
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  align-items: center;
  background: transparent;
  border-radius: 10px;
  padding: 5px 10px;
  width: auto;
  color: #607d8b;

  & + div {
    margin-top: 8px;
  }

  ${props =>
    props.isErrored &&
    css`
      // border-color: #c53030;
      color: #c53030;
    `}

  ${props =>
    props.isFocused &&
    css`
      color: #2196f3;
      //border-color: #2196f3;
    `}

  ${props =>
    props.isField &&
    css`
      color: #78909c;
    `}

  select {
    flex: 1;
    background: transparent;
    border: 0;
    font-size: 1.2rem;
    font-weight: 600;
    color: var(--azul-razio);
		text-transform: uppercase;
		cursor: pointer;

    :focus {
      box-shadow: 0 0 0 0;
      border: 0 none;
      outline: 0;
    }

    option {
      color: #000;
    }
  }

  svg {
    font-size: 30px;
    margin-right: 10px;
  }
`;

export const Error = styled(Tooltip)`
  height: 20px;
  margin-left: 16px;

  svg {
    margin: 0;
  }

  span {
    background: #c53030;
    color: #fff !important;

    &::before {
      border-color: #c53030 transparent;
    }
  }
`;
